<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">

      <article id="cookie-gdpr" class="white-box" role="dialog">
        <div class="text-center">
          <h1>Odense Rundt bruger cookies</h1>
        </div>

        <div>
          <p>Vi indsamler oplysninger om dine besøg med cookies for at analysere trafik, tilpasse vores indhold og forbedre brugeroplevelsen.</p>
          <p>
            Læs mere om <router-link :to="{path: '/privatlivspolitik'}" class="underline">cookies.</router-link><br>
          </p>

          <div class="col-12 btn-div no-pad-both">
            <button class="btn btn-deny grey pointer col-sm-12 col-md-5" @click="saveCookieSettings();" v-html="btnText"></button>

            <button class="btn btn-accept green pointer col-sm-12 col-md-5" @click="saveCookieSettings(true);">Accepter alle</button>
          </div>


          <div class="col-12 details-btn">
            <button class="btn-reset pointer" @click="showDetails = !showDetails">
              <span class="underline" v-if="!showDetails">Vis detaljer</span>
              <span class="underline" v-if="showDetails">Skjul detaljer</span>
            </button>
          </div>

          <div class="cookie-overview col-12 grey" :class="{'hidden' : showDetails == false}">

            <div class="row cookie-category" @click="showNecessaryCookies = !showNecessaryCookies;">
              <div class="col-3 cookie-category-headline">
                <span>Nødvendige</span>
                <span class="material-icons">keyboard_arrow_down</span>
              </div>
              <div class="col-9 text-explanation">
                <p>
                  Nødvendige cookies hjælper med at gøre en hjemmeside brugbar ved at aktivere grundlæggende funktioner, såsom cookie indstillinger og adgang til sikre områder af hjemmesiden.
                  Hjemmesiden kan ikke fungere optimalt uden disse cookies.
                </p>
              </div>
            </div>

            <CookieList v-show="showNecessaryCookies == true" :cookieData="necessaryCookieData"></CookieList>

            <div class="row cookie-category" @click="showFunctionalCookies = !showFunctionalCookies;">
              <div class="col-3 cookie-category-headline">
                <span>Funktionelle</span>
                <span class="material-icons">keyboard_arrow_down</span>
              </div>
              <div class="col-9 text-explanation">
                <p>
                  Vi bruger cookies til at gemme dine foretrukne indstillinger og valg på hjemmesiden. Det gør vi for at kunne vise dig den version af hjemmesiden, der passer til dine præferencer.
                </p>
              </div>
            </div>

            <CookieList v-show="showFunctionalCookies == true" :cookieData="functionalCookieData"></CookieList>

            <div class="row cookie-category" @click="showStatisticCookies = !showStatisticCookies;">
              <div class="col-3 cookie-category-headline">
                <span>Statistiske</span>
                <span class="material-icons">keyboard_arrow_down</span>
              </div>
              <div class="col-9 text-explanation">
                <p>
                  Vi indsamler oplysninger om, hvordan du interagerer med hjemmesiden, herunder hvor ofte du besøger siden, og hvilke sider du kigger på.
                  Det gør vi for at kunne optimere design, brugervenlighed og styrke effektiviteten af hjemmesiden.
                </p>
              </div>
            </div>

            <CookieList v-show="showStatisticCookies == true" :cookieData="statisticsCookieData"></CookieList>

          </div>

        </div>

        <div class="row cookie-toggles grey">

          <div class="col-sm-4 col-6">
            Nødvendige<br>
            <div class="switch">
              <input type="checkbox" class="necessary-cookies" disabled checked aria-label="Nødvendige cookies">
              <span class="slider round"></span>
            </div>
          </div>

          <div class="col-sm-4 col-6">
            Funktionelle<br>
            <div class="switch" @click="changeCookieSetting('acceptFunctional')">
              <input type="checkbox" v-model="acceptFunctional" aria-label="Funktionelle cookies">
              <span class="slider round"></span>
            </div>
          </div>

          <div class="col-sm-4 col-6">
            Statistik<br>
            <div class="switch" @click="changeCookieSetting('acceptStatistic')">
              <input type="checkbox" v-model="acceptStatistic" aria-label="Statistiske cookies">
              <span class="slider round"></span>
            </div>
          </div>

        </div>

      </article>
    </div>

  </transition>
</template>

<script>
import { EventBus } from '@/main.js'
import CookieList from '@/components/cookies/CookieList.vue'

export default {
  data() {
    return {
      btnText: 'Afvis alle',
      acceptFunctional: false,
      acceptStatistic: false,
      showDetails: false,
      showNecessaryCookies: false,
      showFunctionalCookies: false,
      showStatisticCookies: false,
      //NecessaryCookies
      necessaryCookieData: [
        {
          serviceName: 'Odense Rundt',
          purpose: 'Gemmer brugerens cookie-samtykke-tilstand.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: '1 år',
          cookieName: 'OdenseRundt-CookieNotice',
          providerName: 'Odenserundt.dk'
        },
        {
          serviceName: 'Odense Rundt',
          purpose: 'Gemmer brugerens cookie-samtykke-tilstand for funktionelle cookies.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: '1 år',
          cookieName: 'OdenseRundt-FunctionalCookies',
          providerName: 'Odenserundt.dk'
        },
        {
          serviceName: 'Odense Rundt',
          purpose: 'Gemmer brugerens cookie-samtykke-tilstand for statistiske cookies.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: '1 år',
          cookieName: 'OdenseRundt-StatisticsCookies',
          providerName: 'Odenserundt.dk'
        },
        // {
        //   serviceName: 'Odense Rundt',
        //   purpose: 'Lader brugeren forblive logget ind.',
        //   privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
        //   expirationDate: 'Aldrig',
        //   cookieName: 'OdenseRundt-Login',
        //   providerName: 'OdenseRundt.dk'
        // },
        {
          serviceName: 'Odense Rundt',
          purpose: 'Anvendes til filtrering af tag indhold.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'Aldrig',
          cookieName: 'OdenseRundt-FilterOption-xxx',
          providerName: 'OdenseRundt.dk'
        },
      ],
      //FunctionalCookies
      functionalCookieData: [
        {
          serviceName: 'Odense Rundt',
          purpose: 'Huske indstillinger for hjælpetekster.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'Aldrig',
          cookieName: 'OdenseRundt-Tutorialxxx',
          providerName: 'OdenseRundt.dk'
        },
        {
          serviceName: 'Odense Rundt',
          purpose: 'Huske hvilke notifikationer der er blevet vist.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'Aldrig',
          cookieName: 'OdenseRundt-Notification-xxx',
          providerName: 'OdenseRundt.dk'
        },
        {
          serviceName: 'Odense Rundt',
          purpose: 'Huske brugerens valg af liste sortering på tags.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'Aldrig',
          cookieName: 'OdenseRundt-TagSortBy-xxx',
          providerName: 'OdenseRundt.dk'
        },
        {
          serviceName: 'Odense Rundt',
          purpose: 'Huske brugerens adresse historik på ruteplanlæggeren.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'Aldrig',
          cookieName: 'OdenseRundt-DestinationHistory',
          providerName: 'OdenseRundt.dk'
        },
        {
          serviceName: 'Odense Rundt',
          purpose: 'Huske brugerens valg af lag på ruteplanlægger kortet.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'Aldrig',
          cookieName: 'OdenseRundt-OverlayOption-xxx',
          providerName: 'OdenseRundt.dk'
        },
      ],
      //StatisticsCookies
      statisticsCookieData: [
        {
          serviceName: 'Odense Rundt',
          purpose: 'Sessions id til statistik for brug af sidens funktioner.',
          privacyPolitics: '<a href="https://odenserundt.dk/privatlivspolitik" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'Session',
          cookieName: 'OdenseRundt-SessionId',
          providerName: 'Odenserundt.dk'
        },
        {
          serviceName: 'SiteImprove',
          purpose: 'Indsamler oplysninger om brugerne og deres aktivitet på websitet til analyse og rapporteringsformål.',
          privacyPolitics: '<a href="https://siteimprove.com/en/privacy/" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'en måned',
          cookieName: '_cdduid',
          providerName: '.siteimproveanalytics.com'
        },
        {
          serviceName: 'SiteImprove',
          purpose: 'Indsamler oplysninger om brugerne og deres aktivitet på websitet til analyse og rapporteringsformål.',
          privacyPolitics: '<a href="https://siteimprove.com/en/privacy/" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'Session',
          cookieName: 'siteimproveses',
          providerName: '293239.global.siteimproveanalytics.io'
        },
        {
          serviceName: 'SiteImprove',
          purpose: 'Indsamler oplysninger om brugerne og deres aktivitet på websitet til analyse og rapporteringsformål.',
          privacyPolitics: '<a href="https://siteimprove.com/en/privacy/" target="_blank">Privatlivspolitik</a>',
          expirationDate: 'Session',
          cookieName: 'AWSELB',
          providerName: '293239.global.siteimproveanalytics.io'
        },
        {
          serviceName: 'SiteImprove',
          purpose: 'Indsamler oplysninger om brugerne og deres aktivitet på websitet til analyse og rapporteringsformål.',
          privacyPolitics: '<a href="https://siteimprove.com/en/privacy/" target="_blank">Privatlivspolitik</a>',
          expirationDate: '3 år',
          cookieName: 'nmstat',
          providerName: '.ico.odense.dk'
        },
      ],
    }
  },
  components: {
    CookieList
  },
  methods: {
    saveCookieSettings(acceptAll) {
      EventBus.$emit('openMessageBox', {message: 'Dit svar er gemt. Du kan på siden Hjælp altid ændre dine indstillinger vedrørende cookies.', btnText: 'Luk'});
      //Set timestamp 1 year from now
      var date = new Date();
      var timeStampYear = date.setFullYear(date.getFullYear() + 1);
  		localStorage.setItem('OdenseRundt-CookieNotice', JSON.stringify({shown: 'true', timeStamp: timeStampYear}));

      if(acceptAll) {
        localStorage.setItem('OdenseRundt-FunctionalCookies', true);
        localStorage.setItem('OdenseRundt-StatisticsCookies', true);
      }
      else {
        (this.acceptFunctional) ? localStorage.setItem('OdenseRundt-FunctionalCookies', true) : localStorage.setItem('OdenseRundt-FunctionalCookies', false);
        (this.acceptStatistic) ? localStorage.setItem('OdenseRundt-StatisticsCookies', true) : localStorage.setItem('OdenseRundt-StatisticsCookies', false);
      }

      this.$emit('cookieNotificationRemove');
  	},

    changeCookieSetting(setting) {
      this[setting] = !this[setting];
      setTimeout(() => {
        if(!this.acceptFunctional && !this.acceptStatistic) {
          this.btnText = 'Afvis alle';
        }
        else {
          this.btnText = 'Gem indstillinger';
        }
      }, 100);
    },
  }
}
</script>

<style lang="css" scoped>
  #cookie-gdpr {
  	height: auto;
    max-height: 100%;
    overflow-y: auto;
  	width: 500px;
  	z-index: 10000;
  	padding: 15px 15px 0px 15px;
  }

  h1 {
    font-size: 20px;
  }

  .details-btn {
    text-align: center;
    margin-top: 20px;
  }

  .cookie-overview {
    margin-top: 10px;
    height: auto;
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .cookie-category {
    padding-top: 5px;
    cursor: pointer;
  }

  .cookie-category-headline {
    vertical-align: top;
    padding-right: 0px;
  }

  .cookie-category-headline .material-icons {
    position: relative;
    top: -5px;
    width: 30px;
  }

  .cookie-category-headline span:first-child {
    position: relative;
    font-weight: 600;
  }

  @media screen and (min-width: 720px) {
    .cookie-category-headline span:first-child {
      top: -15px;
    }
  }

  .cookie-details {
    margin-bottom: 10px;
  }

  /*Cookie toggles*/
  .cookie-toggles {
    height: auto;
    margin-top: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
  }

  .btn-div {
    display: inline-flex;
  }

  @media screen and (max-width: 375px) {
    .btn-accept {
      margin-bottom: 10px;
    }

    .btn-div {
      flex-direction: column-reverse;
    }
  }

  @media screen and (min-width: 376px) {
    .btn-deny {
      position: relative;
      margin-right: auto;
      left: 0;
    }

    .btn-accept {
      position: relative;
      margin-left: auto;
      right: 0;
    }
  }

  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    border-radius: 34px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    border-radius: 50%;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: rgb(0,112,141);
  }

  input.necessary-cookies:checked + .slider {
    background-color: rgba(0,112,141, 0.6);
  }

  input:focus + .slider {
    box-shadow: 0 0 1px rgb(0,112,141);
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
</style>
